//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props:['supManagePurorgList']
}



// WEBPACK FOOTER //
// ./src/page/supplier/view/procure-organ.vue